import { createApp } from 'vue'
import App from './App.vue'
import sendhistComponent from "./components/SendHistComponent.vue";
import { createRouter, createWebHistory } from 'vue-router'

const app = createApp(App)

const routes = [
    { path: '/s-alert/sendhist', name: 'sendhist', component: sendhistComponent },
]

//ルーティングの設定値
const router = createRouter({
    history: createWebHistory(),
    routes,
})

app.use(router)

app.mount('#app')